import { useEffect, useState } from "react";
import useFormStore from "../../store/formData";
import SelectInput from "../SelectInput/SelectInput";

const SelectInputContainer = (props) => {
  const { formData, setFormData } = useFormStore();
  const [value, setValue] = useState("");
  useEffect(() => {
    formData[props.data.id]
      ? setValue(formData[props.data.id])
      : setFormData(
          props.data.id,
          props.data.options && props.data.options[0]?.id,
        );
  }, []);

  useEffect(() => {
    if (props?.addressData?.data) {
      setFormData(
        props.data.id,
        props.step === "provienc"
          ? String(props.addressData?.data?.province_id)
          : String(props.addressData?.data?.city_id),
      );
      props.step === "provienc"
        ? setValue(props.addressData?.data?.province_id)
        : setValue(props.addressData?.data?.city_id);
    }
  }, [props.addressData]);

  function selectChangeHandler(value) {
    setValue(value);
    setFormData(props.data.id, value);
  }

  return (
    <SelectInput
      size="md" // lg , md , sm , null
      label={props.data.name} // string , null
      value={value} // state
      icon={props.data.icon} // string , null
      disabled={false} // boolean , null
      type="text" // text , number , null
      // validation={phoneValidation} // string , null
      placeholder={"انتخاب کنید"} // string , null
      onChange={(e) => {
        selectChangeHandler(e.target.value);
      }} // setState()
      options={props.data.options}
      id={props.data.id}
    />
  );
};

export default SelectInputContainer;
